<template>
    <main id="login-wrapper">
        <div id="loginpage">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url, status: false },
                    { title: 'Login', url: app_url+'/login', status: true }
                ]"
            ></breadcrumb>
            <div class="container py-4">
                <div class="row justify-content-center">
                    <div class="col-md-6">
                        <div id="card-login" class="card mb-4">
                            <div v-if="!showOtp" class="card-body">
                                <h3 class="title">Login</h3>
                                <p>Silahkan login menggunakan No Handphone atau Email yang  Anda daftarkan.</p>
                                <div class="btn-group">
                                    <a @click="changeTab('phone')" class="btn" :class="{'active': currenttab == 'phone'}">No. Handphone</a>
                                    <a @click="changeTab('email')" class="btn" :class="{'active': currenttab == 'email'}">Email</a>
                                </div>
                                <div v-if="currenttab == 'phone'">
                                    <form
                                        method="POST"
                                        @submit.prevent="onSubmit"
                                        @keydown="form.errors.clear($event.target.name)"
                                        enctype="multipart/form-data"
                                    >
                                    <div id="card-register" class="cards">
                                    <div class="card-bodys">

                                        <div v-if="!checkmail" class="form-group row">
                                            <div class="col">
                                            <label v-if="form.errors.has('phonenotfound')" class="label-form" for="hp">
                                                <span class="help-block" v-html="form.errors.get('phonenotfound')"></span>
                                            </label>
                                            <label v-else class="label-form" for="hp">No. Handphone</label>
                                                <div class="phonebox">
                                                   <span class="input62">+62</span>
                                                    <input
                                                        type="number"
                                                        pattern="[0-9]*"
                                                        inputmode="numeric"
                                                        class="form-control form-register"
                                                        id="hp"
                                                        aria-describedby="hp"
                                                        placeholder="8XXXXXXXX"
                                                        v-model="form.phone"
                                                    />
                                                </div>
                                                <span v-if="showWarning">Pastikan nomor Handphone yang digunakan sudah benar, jika sudah silahkan klik Selanjutnya</span>
                                                <span
                                                class="help-block"
                                                v-if="form.errors.has('phone')"
                                                v-html="form.errors.get('phone')"
                                                >
                                                </span>
                                            </div>
                                        </div>
                                        <div class="form-group row" v-if="showFormPhoneEmail">
                                            <div class="col">
                                            <label class="label-form" for="hp">Masukkan Email</label>
                                                <input
                                                    type="text"
                                                    class="form-control form-register"
                                                    placeholder="Masukkan Email"
                                                        v-model="form.email"
                                                />
                                                <span
                                                class="help-block"
                                                v-if="form.errors.has('email')"
                                                v-html="form.errors.get('email')"
                                                >
                                                </span>
                                            </div>
                                        </div>

                                        <div class="form-group row" v-if="showFormPhonePin">
                                            <div class="col">
                                                <label class="label-form" for="pin">Pin</label>
                                                <div class="input-group">
                                                    <input
                                                        :type="showPin ? 'number' : 'password'"
                                                        pattern="[0-9]*"
                                                        inputmode="numeric"
                                                        class="form-control form-register"
                                                        @change="changePin"
                                                        placeholder="PIN Harus berupa 6 Angka"
                                                        v-model="form.pin"
                                                        v-mask="'######'"
                                                    />
                                                    <span class="input-group-append">
                                                        <button type="button" class="btn btn-red show-hide" @click="showingPin">
                                                            <i :class="{'ion-eye' : !showPin, 'ion-eye-disabled' : showPin}"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                                <span
                                                class="help-block"
                                                v-if="form.errors.has('pin')"
                                                v-html="form.errors.get('pin')"
                                                >
                                                </span>
                                            </div>
                                        </div>
                                        <div class="row-button-box" >
                                            <div v-if="loader" class="loading loading-double"></div>
                                            <button v-else
                                            type="submit"
                                            class="btn btn-red mr-auto"
                                            data-toggle="modal"
                                            >
                                            Login
                                            </button>
                                        </div>
                                    </div>
                                    </div>
                                    </form>
                                </div>
                                <div v-if="currenttab == 'email'">
                                    <form
                                        method="POST"
                                        @submit.prevent="onSubmitEmail"
                                        @keydown="formEmail.errors.clear($event.target.name)"
                                        enctype="multipart/form-data"
                                    >
                                    <div id="card-register" class="cards">
                                    <div class="card-bodys">

                                        <div v-if="!checkphone" class="form-group row">
                                            <div class="col">
                                            <label v-if="formEmail.errors.has('emailnotfound')" class="label-form" for="Email">
                                                <span class="help-block" v-html="formEmail.errors.get('emailnotfound')"></span>
                                            </label>
                                            <label v-else class="label-form" for="Email">Email</label>
                                                <input
                                                    type="text"
                                                    class="form-control form-register"
                                                    placeholder="Masukkan Email"
                                                        v-model="formEmail.email"
                                                />
                                                <span
                                                class="help-block"
                                                v-if="formEmail.errors.has('email')"
                                                v-html="formEmail.errors.get('email')"
                                                >
                                                </span>

                                            </div>
                                        </div>
                                        <div class="form-group row" v-if="showFormEmailPhone">
                                            <div class="col">
                                            <label class="label-form" for="hp">Masukkan No. Handphone</label>
                                                <div class="phonebox">
                                                   <span class="input62">+62</span>
                                                    <input
                                                        type="number"
                                                        pattern="[0-9]*"
                                                        inputmode="numeric"
                                                        class="form-control form-register"
                                                        id="hp"
                                                        aria-describedby="hp"
                                                        placeholder="8XXXXXXXX"
                                                        v-model="formEmail.phone"
                                                    />
                                                </div>
                                                <span v-if="showWarning">Pastikan nomor Handphone yang digunakan sudah benar, jika sudah silahkan klik Selanjutnya</span>
                                                <span
                                                class="help-block"
                                                v-if="formEmail.errors.has('phone')"
                                                v-html="formEmail.errors.get('phone')"
                                                >
                                                </span>
                                            </div>
                                        </div>

                                        <div class="form-group row" v-if="showFormEmailPin">
                                            <div class="col">
                                                <label class="label-form" for="pin">Pin</label>
                                                <div class="input-group">
                                                    <input
                                                        :type="showPin ? 'number' : 'password'"
                                                        pattern="[0-9]*"
                                                        inputmode="numeric"
                                                        class="form-control form-register"
                                                        placeholder="PIN Harus berupa 6 Angka"
                                                        v-model="formEmail.pin"
                                                        v-mask="'######'"
                                                    />
                                                    <span class="input-group-append">
                                                        <button type="button" class="btn btn-red show-hide" @click="showingPin">
                                                            <i :class="{'ion-eye' : !showPin, 'ion-eye-disabled' : showPin}"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                                <span
                                                    class="help-block"
                                                    v-if="formEmail.errors.has('pin')"
                                                    v-html="formEmail.errors.get('pin')"
                                                >
                                                </span>
                                            </div>
                                        </div>
                                        <div class="row-button-box" >
                                            <div v-if="loader" class="loading loading-double"></div>
                                            <button v-else
                                            type="submit"
                                            class="btn btn-red mr-auto"
                                            data-toggle="modal"
                                            >
                                            Login
                                            </button>
                                        </div>
                                    </div>
                                    </div>
                                    </form>
                                </div>
                                <div class="row-forgot">
                                   <a :href="app_url+'/forgot'" class="btn btn-white"> Klik  disini jika  <strong> Lupa Akun/PIN</strong> </a>
                                   <a :href="app_url+'/forgot'" class="btn btn-white">Klik  disini jika  <strong> Belum Pernah Membuat PIN</strong> </a>
                                    <span class="info-text-line"> <span>Belum punya akun ?</span></span>
                                    <a :href="registerUrl" class="btn btn-black">Daftar</a>
                                </div>
                                <div class="message-box" v-if="form.errors.has('notfound')">
                                    <div class="message-content">
                                        <div v-html="form.errors.get('notfound')"></div>
                                        <div class="row-button">
                                            <a :href="registerUrl" class="btn btn-red" style="margin:auto;">Daftar Sekarang</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="message-box" v-if="formEmail.errors.has('notfound')">
                                    <div class="message-content">
                                        <div v-html="formEmail.errors.get('notfound')"></div>
                                        <div class="row-button">
                                            <a :href="registerUrl" class="btn btn-red" style="margin:auto;">Daftar Sekarang</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="showOtp" class="card-body" >
                                <div class="message-box" v-if="showMessage">
                                    <div class="message-content">
                                         <h3>Untuk login Anda harus membuat PIN terlebih dahulu.</h3>
                                            <div v-html="member.message"></div>
                                        <button class="btn btn-red" @click="showMessage = !showMessage"> Selanjutnya </button>
                                    </div>
                                </div>
                                <div class="message-box" v-if="showMessageSuccess">
                                    <div class="message-content">
                                            <div v-html="member.message"></div>
                                            <a :href="nexturl" class="btn btn-red">Selanjutnya</a>
                                    </div>
                                </div>
                                <form
                                    method="POST"
                                    @submit.prevent="onSubmitWithOtp"
                                    @keydown="otpForm.errors.clear($event.target.name)"
                                    enctype="multipart/form-data"
                                >
                                <div id="card-register" class="cards">
                                <div class="card-bodys">
                                    <h3 class="title">Verifikasi</h3>
                                    <div class="form-group row">
                                        <div class="col">
                                        <label class="label-form" for="hp">Akun anda</label>
                                            <div class="member-box">
                                                <strong>{{ member.hcid }}</strong>
                                                <span>{{ member.email }}</span>
                                                <span>{{ member.phone }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col">
                                        <label class="label-form" for="hp">Kode OTP</label>
                                        <input
                                            type="number"
                                            pattern="[0-9]*"
                                            inputmode="numeric"
                                            class="form-control form-register"
                                            id="otp"
                                            aria-describedby="otp"
                                            placeholder="Masukkan No OTP"
                                            v-model="otpForm.otp"
                                            v-mask="'######'"
                                        />
                                            <span
                                            class="help-block"
                                            v-if="otpForm.errors.has('otp')"
                                            v-text="otpForm.errors.get('otp')"
                                            >
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col">
                                        <label class="label-form" for="pin">Masukkan PIN Baru</label>
                                        <input
                                            type="number"
                                            pattern="[0-9]*"
                                            inputmode="numeric"
                                            class="form-control form-register"
                                            id="pin"
                                            @change="changePin"
                                            aria-describedby="pin"
                                            placeholder="PIN Harus berupa 6 Angka"
                                            v-model="otpForm.pin"
                                            v-mask="'######'"
                                        />
                                            <span
                                            class="help-block"
                                            v-if="otpForm.errors.has('pin')"
                                            v-text="otpForm.errors.get('pin')"
                                            >
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col">
                                        <label class="label-form" for="hp">Konfirmasi Pin</label>
                                        <input
                                            type="number"
                                            pattern="[0-9]*"
                                            inputmode="numeric"
                                            class="form-control form-register"
                                            aria-describedby="pin_confirmation"
                                            placeholder="Konfirmasi Pin"
                                            v-model="otpForm.pin_confirmation"
                                            v-mask="'######'"
                                        />
                                            <span
                                            class="help-block"
                                            v-if="otpForm.errors.has('pin_confirmation')"
                                            v-text="otpForm.errors.get('pin_confirmation')"
                                            >
                                            </span>
                                        </div>
                                    </div>
                                    <div v-if="loader" class="loading loading-double"></div>
                                    <div  v-else class="row-button">
                                        <div class="sendback">
                                                <button
                                                type="button"
                                                class="btn btn-black"
                                                :disabled="countDown != 0"
                                                @click="backOTp"
                                                >
                                                Kirim Ulang OTP
                                                </button>
                                            <small v-if="countDown > 0"> Kirim Ulang OTP Dalam {{countDown}} Detik</small>
                                        </div>
                                        <button
                                        type="submit"
                                        class="btn btn-red"
                                        >
                                        Verifikasi
                                        </button>
                                    </div>
                                </div>
                                </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import { sha256, sha224 } from 'js-sha256';


export default {
    components: {
        breadcrumb: BreadCrumb
    },
    data() {
        return {
            base_url:'',
            app_url:'',
            api_url:'',
            help_url:null,
            mobile: false,
            token:'',
            loader:false,
            showWarning: false,
            member:{
                hcid:'HC002121',
                phone:'0821021019',
                email:'chit.eureka@gmail.com',
            },
            showPin:false,
            currenttab:'phone',
            checkmail:false,
            checkphone:false,
            endpoint_phone:api_url+"/member/login-handphone-check",
            endpoint_email:api_url+"/member/login-email-check",
            showLoginPhone:true,
            showFormPhoneEmail:false,
            showFormPhonePin:false,
            showFormEmailPhone:false,
            showFormEmailPin:true,
            showMessage:false,
            showMessageSuccess:false,
            nexturl:'',
            countDown:60,
            showOtp:false,
            phonenotfoundmessage:'No. Handphone tidak ditemukan. Masukkan email anda',
            tokenForm: new Form({
                token:'',
            }),
            otpForm: new Form({
                _token:token,
                phone:'',
                otp:'',
                pin:'',
                pin_confirmation:'',
            }),
            form: new Form({
                _token : token,
                phone:'',
                email:'',
                pin:'',
                captcha_token: '',
            }),
            formEmail: new Form({
                _token : token,
                email:'',
                phone:'',
                pin:'',
                captcha_token: '',
            }),
            redirectUrl: null,
            registerUrl: `${app_url}/register/independent`
        };
    },
    watch: {
        formEmail: {
            handler: function(val, oldVal) {
                if(val.email){
                 this.formEmail.email = val.email.toLowerCase();
                }
            },
            deep: true
        },
        form: {
            handler: function(val, oldVal) {
                if(val.email){
                 this.form.email = val.email.toLowerCase();
                }
            },
            deep: true
        }
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.help_url = help_faq_url;
        this.mobile = isMobile;

        if (this.$route.query.redirect !== undefined) {
            this.redirectUrl = this.$route.query.redirect
            this.registerUrl = `${this.registerUrl}?redirect=${this.redirectUrl}`
        }

        if(auth){
                window.location.href = this.app_url + '/logout'
        }
        localStorage.setItem('method', 'Login');
    },
    methods: {
        // loginSuccess(user, loginMethod) {
        //     var getUser = JSON.parse(localStorage.getItem('user'));
        //     var method = localStorage.getItem('method');
        //     var socmed = localStorage.getItem('socmed');
        //     var getPhone = sha256(user.phone);
        //     var phoneEncrypt = sha256(getPhone);
        //     var data = ({
        //         'event': method,
        //         'eventCategory': 'Custom Event',
        //         'eventAction': method,
        //         'eventLabel': loginMethod,
        //         'user_id': phoneEncrypt
        //     });
        //     dataLayer.push(data);
        //     console.log(data, 'tracker');
        //     localStorage.setItem('tracker', JSON.stringify(data));
        // },
        loginTracker(user = null, action, label) {
            var data = ({
                'event': 'login',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': action,// Login Failed,
                'eventDetail.label': label,// for Login Failed: 'error message'
            })

            if (user !== null) {
                var getHcid = user.hcid;
                var getPoint = user.poin.number;
                data.userId = getHcid;
                data.point = getPoint;
                localStorage.setItem('tracker-login', JSON.stringify(data));
            } else {
                dataLayer.push(data);
            }

            // console.log(data, 'tracker');
        },
        showingPin(){
            this.showPin = !this.showPin;
        },
        loginPhone(){
            this.showLoginPhone = true;
        },
        changePin(e){
            console.log(e);
        },
        changeTab(tab){
            this.currenttab = tab;
            this.endpoint_phone = api_url+"/member/login-handphone-check";
            this.endpoint_email = api_url+"/member/login-email-check";
            this.checkmail = false;
            this.checkphone = false;
            this.showFormPhoneEmail = false;
            this.showFormPhonePin = false;
            this.showFormEmailPhone = false;
            this.showFormEmailPin = false;
            this.showMessage = false;
            this.showMessageSuccess = false;
        },
        onSubmit() {
            this.loader = true;
            let that = this;
            grecaptcha.ready(function() {
                grecaptcha.execute(process.env.MIX_GOOGLE_RECAPTCHA_SITE_KEY, {action: 'submit'}).then(function(token) {
                    that.form.captcha_token = token;

                    that.form.post(that.endpoint_phone)
                    .then((response) => {
                        that.loader = false;
                        console.log('is success login = ', response.login)
                        if(response.login){
                            localStorage.setItem('user',JSON.stringify(response.member))
                            // that.loginSuccess(response.member, 'Login Phone Number');
                            that.loginTracker(response.member, 'Login', 'Login Phone Number');
                            
                            if (that.redirectUrl !== null) {
                                window.location.href = that.app_url + that.redirectUrl
                            } else {
                                window.location.href = that.app_url + '/hcid'
                            }
                        }else{
                            if(response.haspin){
                                that.form.phone = response.phone;
                                that.form.email = response.email;
                                that.checkmail = response.checkmail;
                                that.endpoint_phone = api_url+response.endpoint;
                                that.showFormPhonePin = true;
                            }else{
                            if(response.found){
                                that.form.phone = response.phone;
                                that.form.email = response.email;
                                    that.showOtp = true;
                                    that.member = response.member;
                                    that.otpForm.phone = response.member.otp;
                                    that.showMessage = true;
                                    that.countDown = 60;
                                    that.countDownTimer();
                            }
                            }
                        }
                    })
                    .catch((response) => {
                        that.loader = false;
                        if (response.rate_limit !== undefined && response.rate_limit) {
                            that.showFormPhonePin = false;
                            that.form.email = '';
                            that.form.phone = '';
                            that.form.pin = '';
                            that.endpoint_phone = api_url+"/member/login-handphone-check";
                            that.endpoint_email = api_url+"/member/login-email-check";
                            that.checkmail = false;
                            that.checkphone = false;
                            that.showFormPhoneEmail = false;
                            that.showFormPhonePin = false;
                            that.showFormEmailPhone = false;
                            that.showFormEmailPin = false;
                            that.showMessage = false;
                            that.showMessageSuccess = false;
                        }
                        if (response.pin !== undefined) {
                            that.showFormPhonePin = true;
                        }
                        if (response.phone !== undefined) {
                            that.loginTracker(null, 'Login Failed', `Login Failed: ${response.phone[0]}`);
                        } else if (response.phonenotfound !== undefined) {
                            that.loginTracker(null, 'Login Failed', `Login Failed: ${response.phonenotfound}`);
                        } else if (response.email !== undefined) {
                            that.loginTracker(null, 'Login Failed', `Login Failed: ${response.email[0]}`);
                        } else if (response.notfound !== undefined) {
                            that.loginTracker(null, 'Login Failed', `Login Failed: ${response.msg}`);
                        } else if (response.pin !== undefined) {
                            that.loginTracker(null, 'Login Failed', `Login Failed: ${response.pin[0]}`);
                        } else {
                            that.loginTracker(null, 'Login Failed', `Login Failed: Gagal Login!`);
                        }
                        if(response.checkphone){
                            if(response.found){
                            }else{
                                that.showFormPhoneEmail = true;
                            }
                        }
                    });
                });
            });
        },
        onSubmitWithOtp() {
         this.loader = true;
         this.otpForm.post(api_url+"/member/buat-pin-otp")
            .then((response) => {
                if (response.status) {
                    this.member = response.member;
                    localStorage.setItem('user',JSON.stringify(response.member))
                    this.showMessageSuccess = true;
                    this.nexturl = this.app_url + '/hcid';
                }
            })
            .catch((response) => {
               this.loader = false;
                 console.log("ERROR");
            });
        },
        backOTp(){
            this.showOtp = false;
            this.showWarning = true;
        },
        onSubmitEmail() {
            this.loader = true;
            let that = this;
            grecaptcha.ready(function() {
                grecaptcha.execute(process.env.MIX_GOOGLE_RECAPTCHA_SITE_KEY, {action: 'submit'}).then(function(token) {
                    that.formEmail.captcha_token = token;

                    that.formEmail.post(that.endpoint_email)
                    .then((response) => {
                        that.loader = false;
                        if(response.login){
                            localStorage.setItem('user',JSON.stringify(response.member))
                            // that.loginSuccess(response.member, 'Login Email');
                            that.loginTracker(response.member, 'Login', 'Login Email');
                            
                            if (that.redirectUrl !== null) {
                                window.location.href = that.app_url + that.redirectUrl
                            } else {
                                window.location.href = that.app_url + '/hcid'
                            }
                        }else{
                            if(response.haspin){
                                that.formEmail.phone = response.phone ?? '';
                                that.formEmail.email = response.email ?? '';
                                that.checkphone = response.checkphone;
                                that.endpoint_email = api_url+response.endpoint;
                                that.showFormEmailPin = true;
                            }else{
                                if(response.found){
                                    that.formEmail.phone = response.phone ?? '';
                                    that.formEmail.email = response.email ?? '';
                                        that.showOtp = true;
                                        that.member = response.member;
                                        that.otpForm.phone = response.member.otp;
                                        that.showMessage = true;
                                        that.countDown = 60;
                                        that.countDownTimer();
                                }
                            }
                        }
                    })
                    .catch((response) => {
                        that.loader = false;
                        if (response.rate_limit !== undefined && response.rate_limit) {
                            that.showFormEmailPin = false;
                            that.formEmail.email = '';
                            that.formEmail.phone = '';
                            that.formEmail.pin = '';
                            that.endpoint_phone = api_url+"/member/login-handphone-check";
                            that.endpoint_email = api_url+"/member/login-email-check";
                            that.checkmail = false;
                            that.checkphone = false;
                            that.showFormPhoneEmail = false;
                            that.showFormPhonePin = false;
                            that.showFormEmailPhone = false;
                            that.showFormEmailPin = false;
                            that.showMessage = false;
                            that.showMessageSuccess = false;
                        }
                        if (response.pin !== undefined) {
                            that.showFormEmailPin = true;
                        }
                        if (response.phone !== undefined) {
                            that.loginTracker(null, 'Login Failed', `Login Failed: ${response.phone[0]}`);
                        } else if (response.emailnotfound !== undefined) {
                            that.loginTracker(null, 'Login Failed', `Login Failed: ${response.emailnotfound[0]}`);
                        } else if (response.email !== undefined) {
                            that.loginTracker(null, 'Login Failed', `Login Failed: ${response.email[0]}`);
                        } else if (response.notfound !== undefined) {
                            that.loginTracker(null, 'Login Failed', `Login Failed: ${response.msg}`);
                        } else if (response.pin !== undefined) {
                            that.loginTracker(null, 'Login Failed', `Login Failed: ${response.pin[0]}`);
                        } else {
                            that.loginTracker(null, 'Login Failed', `Login Failed: Gagal Login!`);
                        }
                        if(response.checkmail){
                            if(response.found){
                            }else{
                            that.showFormEmailPhone = true;
                            }
                        }
                    });
                });
            });
        },
        countDownTimer() {
            if(this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            }
        },
        getToken() {
        this.tokenForm.post(api_url+"/auth/social/get-token")
            .then((response) => {
                this.token = response.data.token;

                localStorage.setItem('token',this.token)
                this.getUser();
            })
            .catch((response) => {
                        console.log(response);
            });
        },
        getUser() {
                axios.get(api_url+'/member/profile',{
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
                }).then(response => {
                        if(response.data.success){
                            localStorage.setItem('user',JSON.stringify(response.data.data))
                            if(response.data.data.completed==true || response.data.data.completed=='true'){
                                if (this.$route.query.redirect !== undefined) {
                                    window.location.href = this.app_url + this.$route.query.redirect
                                } else {
                                    window.location.href = this.app_url + '/hcid'
                                }
                            }else{
                                window.location.href = this.app_url + '/register-user'
                            }
                        }
                    }).catch(error => {
                        // this.loadderforms = false;
                        // window.location.href = this.app_url + '/login'
                        console.log(error);
                    });
        },
    },
};
</script>

<style scoped lang="scss">
#loginpage{
    background: #000000;
    .show-hide {
        padding-left: 10px !important;
        line-height: 0 !important;
        .ion-eye-disabled::before,
        .ion-eye::before {
            font-size: 20px;
            color: #fff;
        }
    }
    .card-body{
        position: relative;
        color:#333;
        p{
            color:#333;
        }
    }
    .message-box{
        position: absolute;
        background: #fff;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
        .message-content{
            h3{
                color:#E61B33;
            }
            max-width: 80%;
            margin:auto;
            .btn{
                text-align: center;
                max-width: 200px;
            }
            .btn:hover{
                color:#fff;
            }
        }
    }
    .member-box{
        padding: 15px;
        background: #f2f2f2;
        border-radius: 10px;
        strong,span{
            color:#000;
            display: block;
        }
    }
    #card-login{
        background: #FFFFFF;
        border-radius: 10px;
        // font-family: Inter;
    }
    .title{
        color: #000000;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 1rem;
    }
    .btn{
        width:100%;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        padding-left: 0;
        text-align: left;
    }
    #btn-login-google{
        background: #4081EC;
        color: #FFFFFF;
        border-radius: 5px;
    }
    #btn-login-handphone{
        background: #E61B33;
        border-radius: 5px;
        color: #FFFFFF;
    }
    .login-handphone{
        span{
            line-height: 30px;
            font-size: 16px;
            color:#E61B33;
            display: block;
        }
    }
    #btn-login-facebook{
        background: #3B5998;
        border-radius: 5px;
        color: #FFFFFF;
    }
    #btn-login-twitter{
        background: #1DA1F2;
        border-radius: 5px;
        color: #FFFFFF;
    }
    #daftar-link{
        color: #727272;
        font-weight: 300;
        font-size: 14px;
        line-height: 24px;
    }
    .btn:hover{
        background-color: #333 !important;
    }
    .img-button{
        /* max-width: 20px; */
        background: #FFFFFF;
        border-radius: 5px;
    }
    .btn-group{
        width:100%;
        margin-bottom: 20px;
        .btn.active{
            background: #e61b33;
                color:#fff;
        }
        .btn{
            text-align: center;
            margin:0 5px;
            background: #f2f2f2;
            color:#333;
            border-radius: 10px;
            line-height: 1;
            padding:13px 0;
            &:hover{
                color:#fff;
            }
        }
    }
    #icon-section{
        position: absolute;
        left: 19px;
        bottom:4px;
        z-index: 1;
        background-color:white;
        border-radius: 5px;
        width: 30px;
        height: 30px;
    }
    .text-btn{
        margin-left: 45px;
    }
    .row-button{
        display: flex;
        .btn{
            font-weight: bold;
            font-size: 16px;
            padding: 0;
            height: 38px;
            max-width: 115px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover{
                color:#fff;
            }
        }
        .mr-auto{
            margin-right: auto;
        }
        .info-text{
            margin-right: 10px;
        }
        .sendback{
            margin-right: auto;
            .btn{
                min-width: 160px;
            }
        }
    }
    .row-button-box, .row-forgot{
        .btn{
            width: 100%;
            max-width: 100%;
            font-weight: bold;
            font-size: 14px;
            padding: 0;
            height: 42px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover{
                color:#fff;
            }
        }
    }
    .row-forgot{
        padding:10px 0 0 0;
        a,span{
            display: block;
        }
        span.info-text-line{
            text-align: center;
            margin:20px 0;
            position:relative;
            span{
                display: inline-block;
                background: #fff;
                position: relative;
                z-index: 10;
                padding: 0 20px;
            }
            &:before{
                content:'';
                width: 100%;
                height: 1px;
                background: #DBDBDB;
                position: absolute;
                top:50%;
                left:0;
            }
        }
        .btn-white{
            font-weight: normal;
            background: #fff;
            border:1px solid #DBDBDB;
            color:#333;
            margin:15px 0;
            font-size: 14px;
            strong{
                margin:0 5px;
            }
            &:hover{
            background: #fff !important;
            border:solid 1px #E61B33;
            color:#E61B33;
            }
        }
        .btn-black{
            background: #282828;
            &:hover{
            background: #E61B33 !important;
            color:#fff;
            }
        }
    }
}
</style>
